import { v4 as uuidv4 } from "uuid";
import { faker } from "@faker-js/faker";
import {
  CUSTOMER_PREFERENCE,
  ORGANIZATION_BASE_URL,
  ORG_MGR_AVALILABEL_LIST,
  ORG_MGR_LIST_URL,
  SUBSCRIPTION,
} from "../../config/service";

import { FEATURE_PLANS } from "../../utils/app-constants.json";
import { parentOrgId } from "../mockData/multitenancy";

export const activeOrganization = {
  Name: "Acme Inc AWS MSP",
  ID: parentOrgId,
  Description:
    "Acme Inc AWS MSP is a leading Managed Service Provider (MSP) that specializes in helping businesses of all sizes move to and manage their workloads on Amazon Web Services (AWS).",
  ParentOrganizationId: null, // parent demo org
  CreatedOn: "2023-05-02 13:19:26",
  DocumentURL: null,
  Feature: FEATURE_PLANS.AUTOMATED_CLOUD_OPS,
  Owner: faker.number.int({ min: 1, max: 6 }).toString(),
};

const dummyOrganizationNames = [
  {
    name: "TechTrek Solutions",
    id: "85f5ed19-db77-4aeb-95ba-37cc08282f8f",
    description:
      "A software development company specializing in creating innovative mobile applications and web solutions for small businesses.",
  },

  {
    name: "BrightByte Technologies",
    id: "b508803e-b300-4329-a8c5-cff59910daf0",
    description:
      "An IT consulting firm that offers comprehensive cybersecurity services, including network security, vulnerability assessments, and data protection.",
  },
  {
    name: "CloudCo Solutions",
    id: "26fd96d5-15d3-4a26-8464-7b2cddb06d58",
    description:
      "Provides cloud-based infrastructure and managed IT services to help businesses optimize their operations and enhance productivity.",
  },

  {
    name: "DataWave Analytics",
    id: "e17ad542-d822-4c37-958a-e4c9aa7991f5",
    description:
      "A data analytics company that assists organizations in extracting valuable insights from their data through advanced analytics tools and techniques.",
  },

  {
    name: "Marketing Maven",
    id: "e790679d-8388-4b5d-acc9-578851a095f5",
    description:
      "A digital marketing agency that helps SMBs boost their online presence and attract customers through strategic social media marketing and search engine optimization.",
  },

  {
    name: "EcoTech Innovations",
    id: "96ac00d8-2c7c-4781-bcb0-465c6daf0ff0",
    description:
      "Offers sustainable technology solutions for businesses, including energy-efficient devices, recycling programs, and eco-friendly consulting services.",
  },

  {
    name: "HRXpert Partners",
    id: "8e6477c3-5745-4765-8ba0-fd5108ad8cbe",
    description:
      "A human resources consulting firm that provides SMBs with tailored HR solutions, including recruitment, employee training, and compliance assistance.",
  },

  {
    name: "FreshBite Catering",
    id: "84344f38-b938-496c-af4a-c01a4e3efeaf",
    description:
      "A catering company specializing in providing fresh and healthy meals for corporate events, offering a wide range of customizable menus to meet specific dietary needs.",
  },

  {
    name: "PrintPro Printers",
    id: "0adb0f77-30f1-41f5-a409-66f4e9443799",
    description:
      "A print and design company that offers high-quality printing services, promotional materials, and customized branding solutions for small businesses.",
  },

  {
    name: "TravelEase Adventures",
    id: "cc9ebfe9-02f4-460d-babc-f84d6211bbd7",
    description:
      "A travel agency that curates unique and personalized travel experiences for SMBs, including team-building retreats, corporate getaways, and incentive trips.",
  },

  {
    name: "HumanTech University",
    id: "adaa103f-2bd9-427a-bfda-1d5164d33b50",
    description: "Cloud IT Department",
  },
];

const numberOfOrggs = dummyOrganizationNames.length - 1;

const someOrganizationIds = Array(numberOfOrggs)
  .fill(0)
  .map((_) => uuidv4());

someOrganizationIds.push("e514d2d2-dcb8-4daf-9a7d-93feb7eedf3c");

export const customerPreferencesBasic = ["Visibility", "WellArchitectedReview"];

export const customerPreferencesAdvance = [
  "Visibility",
  "WellArchitectedReview",
  "WellArchitectedReviewRemediation",
  "CloudGorvernance",
  "ServerManagement",
  "ApplicationManagement",
];

export const setupMTServices = (mock) => {
  const orgMgrBaseUrl = new RegExp(`org/organization/${parentOrgId}`);

  mock.onGet(orgMgrBaseUrl).reply(() => {
    return [200, activeOrganization];
  });

  // orgs for swithcer
  mock.onGet(ORG_MGR_LIST_URL).reply(async () => {
    let organisation = Array(numberOfOrggs)
      .fill(0)
      .map((org, index) => {
        return {
          ID: dummyOrganizationNames[index].id,
          Description: dummyOrganizationNames[index].description,
          Name: dummyOrganizationNames[index].name,
          ParentOrganizationId: parentOrgId,
        };
      });

    organisation = [activeOrganization, ...organisation];

    return [200, organisation];
  });

  // settings organizations
  mock.onGet(ORG_MGR_AVALILABEL_LIST).reply(() => {
    let organisation = Array(numberOfOrggs)
      .fill(0)
      .map((_, index) => {
        return {
          ID: dummyOrganizationNames[index].id,
          Description: dummyOrganizationNames[index].description,
          Name: dummyOrganizationNames[index].name,
          ParentOrganizationId: parentOrgId,
          Owner: faker.number.int({ min: 1, max: 6 }).toString(),
          CreatedOn: faker.date.past().toString(),
          Feature: faker.helpers.arrayElement(Object.values(FEATURE_PLANS)),
        };
      });

    organisation.push(activeOrganization);

    return [200, organisation];
  });

  // invite users
  mock.onGet(/\/auth\/users\?OrganizationId=[0-9a-zA-Z-]+/g).reply((config) => {
    let users = Array(5)
      .fill(0)
      .map((_) => {
        return {
          CreatedBy: parentOrgId,
          CreatedOn: "2023-05-02",
          Email: faker.internet.email(),
          FederatedBy: "DAY2",
          FederationSettings: null,
          ID: uuidv4(),
          IdentityType: ["DAY2"],
          LoginCountWithoutMFA: 0,
          MFAConfigured: null,
          Metadata: null,
          Name: faker.name.firstName(),
          Roles: [
            {
              Dept: "*",
              Org: "033acfbf-8a84-4015-a2f2-17c66311cfd2",
              Role: "c71db059-6b93-4a95-9092-6d22d73a7fc6",
            },
          ],
          Status: "Active",
        };
      });

    return [200, users];
  });

  // Create Tenant
  mock.onPost(ORGANIZATION_BASE_URL).reply(() => {
    return [
      200,
      {
        ID: someOrganizationIds[2],
        Description: faker.lorem.sentences(2),
        Name: `${faker.name.firstName()} ${faker.name.lastName()}`,
        ParentOrganizationId: parentOrgId,
        Owner: faker.number.int({ min: 1, max: 6 }).toString(),
        CreatedOn: faker.date.past().toString(),
      },
    ];
  });

  // Get Single Tenant Details
  const singleOrgUrl = new RegExp("/org/organization/[0-9a-zA-Z-]+$");

  mock.onGet(singleOrgUrl).reply((config) => {
    let ID = config.url.split("/")[3];
    let index = someOrganizationIds.indexOf(ID);

    return [
      200,
      {
        ID,
        Description: dummyOrganizationNames[index].description,
        Name: dummyOrganizationNames[index].name,
        ParentOrganizationId: parentOrgId,
        Owner: faker.number.int({ min: 1, max: 6 }).toString(),
        CreatedOn: faker.date.past().toString(),
      },
    ];
  });

  mock
    .onPost(/\/auth\/users\/[0-9a-zA-Z-]+\/assign-org\/[0-9a-zA-Z-]+/g)
    .reply(() => {
      return [200, { success: true }];
    });

  mock
    .onPost(/\/auth\/switch-context\/organization\/[0-9a-zA-Z-]+/g)
    .reply(() => {
      return [200, { success: true }];
    });

  mock.onPut(new RegExp(`${CUSTOMER_PREFERENCE}/[0-9a-zA-Z-]+`)).reply(() => {
    return [
      200,
      {
        Preference: [
          "Visibility",
          "WellArchitectedReview",
          "WellArchitectedReviewRemediation",
          "CloudGorvernance",
          "ServerManagement",
          "ApplicationManagement",
        ],
      },
    ];
  });

  mock
    .onDelete(/\/auth\/users\/[0-9a-zA-Z-]+\/unassign-org\/[0-9a-zA-Z-]+/g)
    .reply(() => {
      return [200];
    });

  const subcriptionUrl = new RegExp(`${SUBSCRIPTION}`);

  mock.onPost(subcriptionUrl).reply(() => {
    return [
      200,
      {
        Message: "Successfully subscribed",
        SubscriptionId: "ef41ab8b-7d71-4006-a1cb-104f651e5a36",
      },
    ];
  });
};
